<template>
  <div>
    <div class="footer content">
      <div class="list-wrap">
        <div class="wrap" v-for="(item, index) in list" :key="index">
          <div class="title">{{item.title}}</div>
          <div class="sub-title" v-for="(child,i) in item.infos" :key="'c' + i">
            <a v-if="child.type =='link'" :href="child.url" target="view_window">{{child.title}}</a>
            <div v-else-if="child.type =='richtext'" @click="view(child.content)">{{child.title}}</div>
          </div>
        </div>
      </div>
      <div class="wx">
        <div class="contact">
          <div> <i class="el-icon-phone"></i> 400-820-9069</div>
          <div> <i class="el-icon-time"></i> 周一至周五 8:30-17:00</div>
          <div> <i class="el-icon-message"></i> report@sfsci.com</div>
        </div>
        <!-- <div class="txt-center qrcode">
          <img :src="platformConfig.wechat_official_account_logo" alt="">
          <div>关注微信公众号</div>
        </div> -->
      </div>
    </div>
    <div class="txt-center footer1">
      <div>{{webCopyRight}}</div>
      <div>{{webcomName}}</div>
      <div>
        <a class="copyright" href="http://www.beian.miit.gov.cn/" target="_blank">{{webFillInfor}}</a>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  export default {
    name: 'Footer',
    data() {
      return {
        webCopyRight: '',
        webcomName: '',
        webFillInfor: '',
        list: []
      }
    },
    computed: {},

    mounted() {
      this.doorCateList()
      this.getSetting()
    },
    beforeRouteLeave: (to, from, next) => { // 写在前一个组件
      to.meta.keepAlive = false
      next()
    },
    methods: {
      doorCateList() {
        this.$http.doorCateList({
          type: 'website'
        }).then(res => {
          if (res.code == 0) {
            this.list = res.data.data
            // console.log(this.list)
          }
        })
      },
      view(msg) {
        // console.log(this.$route)
        // 就是这里跳转咋搞

        if (this.$route.path == '/home') {
          this.$router.push({
            name: 'footView',
            params: {
              msg: msg
            }
          })
        } else {
          this.$emit('valueObject', msg)
        }
      },
      getSetting() {
        this.$http.getSetList({
          keys: 'website_copyright,website_company_name,website_fill_information'
        }).then(res => {
          if (res.code == 0) {
            this.webCopyRight = res.data.website_copyright
            this.webcomName = res.data.website_company_name
            this.webFillInfor = res.data.website_fill_information
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .footer {
    display: flex;
    justify-content: space-around;
    padding: 30px 0;
    font-size: 14px;

    .list-wrap {
      display: flex;
      justify-content: space-around;
      flex: 3;
      border-right: 1px solid #ccc;
    }

    .wrap {
      color: #ccc;
      line-height: 2;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 16px;

      .title {
        color: #ccc;
        margin-bottom: 5px;
        font-weight: 600;
        font-size: 18px;
        cursor: default;
      }

      .sub-title {}

      .sub-title:hover {
        color: #fff;
        cursor: pointer;
      }
    }

    .wx {
      flex: 2;
      display: flex;
      align-items: center;
      justify-content: space-around;
      font-size: 16px;
      color: #199ED8;
      font-weight: 600;
      line-height: 2;

      img {
        width: 100px;
        height: 100px;
        border: 1px solid #eee;
      }

      .qrcode {
        font-size: 14px;
        color: #fff;
        font-weight: 500;
      }
    }
  }

  .footer1 {
    height: 80px;
    color: #C9C9C9;
    padding-top: 30px;
    line-height: 2;
    background-color: #363636;
    font-size: 12px;
  }

  .txt-center {
    text-align: center;
  }

  .copyright {
    color: #B7B7B7;
    text-decoration: none;
  }

  //a标签进行跳转的时候的颜色
  .sub-title {
    a {
      color: #ccc;
      text-decoration: none;
    }

    a:hover {
      color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header/Footer.vue